import CampaignContactDto from '@/models/CampaignContacts/CampaignContactDto';

export default class CampaignContactsViewModel {
    selectedContactId = '';
    selectedCampaignContact: CampaignContactDto = null;
    campaignContacts: CampaignContactDto[] = [];
}